var D;
(function(r) {
  r.assertEqual = (n) => {
  };
  function e(n) {
  }
  r.assertIs = e;
  function t(n) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (n) => {
    const i = {};
    for (const s of n)
      i[s] = s;
    return i;
  }, r.getValidEnumValues = (n) => {
    const i = r.objectKeys(n).filter((o) => typeof n[n[o]] != "number"), s = {};
    for (const o of i)
      s[o] = n[o];
    return r.objectValues(s);
  }, r.objectValues = (n) => r.objectKeys(n).map(function(i) {
    return n[i];
  }), r.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const i = [];
    for (const s in n)
      Object.prototype.hasOwnProperty.call(n, s) && i.push(s);
    return i;
  }, r.find = (n, i) => {
    for (const s of n)
      if (i(s))
        return s;
  }, r.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n;
  function a(n, i = " | ") {
    return n.map((s) => typeof s == "string" ? `'${s}'` : s).join(i);
  }
  r.joinValues = a, r.jsonStringifyReplacer = (n, i) => typeof i == "bigint" ? i.toString() : i;
})(D || (D = {}));
var Qa;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(Qa || (Qa = {}));
const y = D.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ne = (r) => {
  switch (typeof r) {
    case "undefined":
      return y.undefined;
    case "string":
      return y.string;
    case "number":
      return Number.isNaN(r) ? y.nan : y.number;
    case "boolean":
      return y.boolean;
    case "function":
      return y.function;
    case "bigint":
      return y.bigint;
    case "symbol":
      return y.symbol;
    case "object":
      return Array.isArray(r) ? y.array : r === null ? y.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? y.promise : typeof Map < "u" && r instanceof Map ? y.map : typeof Set < "u" && r instanceof Set ? y.set : typeof Date < "u" && r instanceof Date ? y.date : y.object;
    default:
      return y.unknown;
  }
}, m = D.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
let ce = class Nr extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (a) => {
      this.issues = [...this.issues, a];
    }, this.addIssues = (a = []) => {
      this.issues = [...this.issues, ...a];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, a = { _errors: [] }, n = (i) => {
      for (const s of i.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(n);
        else if (s.code === "invalid_return_type")
          n(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          n(s.argumentsError);
        else if (s.path.length === 0)
          a._errors.push(t(s));
        else {
          let o = a, d = 0;
          for (; d < s.path.length; ) {
            const u = s.path[d];
            d === s.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(t(s))) : o[u] = o[u] || { _errors: [] }, o = o[u], d++;
          }
        }
    };
    return n(this), a;
  }
  static assert(e) {
    if (!(e instanceof Nr))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, D.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, a = [];
    for (const n of this.issues)
      if (n.path.length > 0) {
        const i = n.path[0];
        t[i] = t[i] || [], t[i].push(e(n));
      } else
        a.push(e(n));
    return { formErrors: a, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
};
ce.create = (r) => new ce(r);
const at = (r, e) => {
  let t;
  switch (r.code) {
    case m.invalid_type:
      r.received === y.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case m.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, D.jsonStringifyReplacer)}`;
      break;
    case m.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${D.joinValues(r.keys, ", ")}`;
      break;
    case m.invalid_union:
      t = "Invalid input";
      break;
    case m.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${D.joinValues(r.options)}`;
      break;
    case m.invalid_enum_value:
      t = `Invalid enum value. Expected ${D.joinValues(r.options)}, received '${r.received}'`;
      break;
    case m.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case m.invalid_return_type:
      t = "Invalid function return type";
      break;
    case m.invalid_date:
      t = "Invalid date";
      break;
    case m.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : D.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case m.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "bigint" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case m.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case m.custom:
      t = "Invalid input";
      break;
    case m.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case m.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case m.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, D.assertNever(r);
  }
  return { message: t };
};
let Br = at;
function Yr() {
  return Br;
}
const Kr = (r) => {
  const { data: e, path: t, errorMaps: a, issueData: n } = r, i = [...t, ...n.path || []], s = {
    ...n,
    path: i
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: i,
      message: n.message
    };
  let o = "";
  const d = a.filter((u) => !!u).slice().reverse();
  for (const u of d)
    o = u(s, { data: e, defaultError: o }).message;
  return {
    ...n,
    path: i,
    message: o
  };
};
function p(r, e) {
  const t = Yr(), a = Kr({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === at ? void 0 : at
      // then global default map
    ].filter((n) => !!n)
  });
  r.common.issues.push(a);
}
let B = class Wr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const a = [];
    for (const n of t) {
      if (n.status === "aborted")
        return C;
      n.status === "dirty" && e.dirty(), a.push(n.value);
    }
    return { status: e.value, value: a };
  }
  static async mergeObjectAsync(e, t) {
    const a = [];
    for (const n of t) {
      const i = await n.key, s = await n.value;
      a.push({
        key: i,
        value: s
      });
    }
    return Wr.mergeObjectSync(e, a);
  }
  static mergeObjectSync(e, t) {
    const a = {};
    for (const n of t) {
      const { key: i, value: s } = n;
      if (i.status === "aborted" || s.status === "aborted")
        return C;
      i.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof s.value < "u" || n.alwaysSet) && (a[i.value] = s.value);
    }
    return { status: e.value, value: a };
  }
};
const C = Object.freeze({
  status: "aborted"
}), rt = (r) => ({ status: "dirty", value: r }), q = (r) => ({ status: "valid", value: r }), er = (r) => r.status === "aborted", tr = (r) => r.status === "dirty", ye = (r) => r.status === "valid", Re = (r) => typeof Promise < "u" && r instanceof Promise;
var b;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e?.message;
})(b || (b = {}));
let de = class {
  constructor(e, t, a, n) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = a, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const ar = (r, e) => {
  if (ye(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new ce(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function A(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: a, description: n } = r;
  if (e && (t || a))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (i, s) => {
    const { message: o } = r;
    return i.code === "invalid_enum_value" ? { message: o ?? s.defaultError } : typeof s.data > "u" ? { message: o ?? a ?? s.defaultError } : i.code !== "invalid_type" ? { message: s.defaultError } : { message: o ?? t ?? s.defaultError };
  }, description: n };
}
class z {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return ne(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: ne(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new B(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: ne(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Re(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const a = this.safeParse(e, t);
    if (a.success)
      return a.data;
    throw a.error;
  }
  safeParse(e, t) {
    const a = {
      common: {
        issues: [],
        async: t?.async ?? !1,
        contextualErrorMap: t?.errorMap
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ne(e)
    }, n = this._parseSync({ data: e, path: a.path, parent: a });
    return ar(a, n);
  }
  "~validate"(e) {
    var t, a;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ne(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: n });
        return ye(i) ? {
          value: i.value
        } : {
          issues: n.common.issues
        };
      } catch (i) {
        (a = (t = i?.message) == null ? void 0 : t.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((i) => ye(i) ? {
      value: i.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, t) {
    const a = await this.safeParseAsync(e, t);
    if (a.success)
      return a.data;
    throw a.error;
  }
  async safeParseAsync(e, t) {
    const a = {
      common: {
        issues: [],
        contextualErrorMap: t?.errorMap,
        async: !0
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ne(e)
    }, n = this._parse({ data: e, path: a.path, parent: a }), i = await (Re(n) ? n : Promise.resolve(n));
    return ar(a, i);
  }
  refine(e, t) {
    const a = (n) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(n) : t;
    return this._refinement((n, i) => {
      const s = e(n), o = () => i.addIssue({
        code: m.custom,
        ...a(n)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((d) => d ? !0 : (o(), !1)) : s ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((a, n) => e(a) ? !0 : (n.addIssue(typeof t == "function" ? t(a, n) : t), !1));
  }
  _refinement(e) {
    return new be({
      schema: this,
      typeName: E.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return se.create(this, this._def);
  }
  nullable() {
    return xe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return _e.create(this);
  }
  promise() {
    return Fe.create(this, this._def);
  }
  or(e) {
    return He.create([this, e], this._def);
  }
  and(e) {
    return Ie.create(this, e, this._def);
  }
  transform(e) {
    return new be({
      ...A(this._def),
      schema: this,
      typeName: E.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new ut({
      ...A(this._def),
      innerType: this,
      defaultValue: t,
      typeName: E.ZodDefault
    });
  }
  brand() {
    return new xn({
      typeName: E.ZodBranded,
      type: this,
      ...A(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new lt({
      ...A(this._def),
      innerType: this,
      catchValue: t,
      typeName: E.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Mn.create(this, e);
  }
  readonly() {
    return ct.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Gr = /^c[^\s-]{8,}$/i, Qr = /^[0-9a-z]+$/, en = /^[0-9A-HJKMNP-TV-Z]{26}$/i, tn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, an = /^[a-z0-9_-]{21}$/i, rn = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, nn = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, sn = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, on = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ge;
const dn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, un = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ln = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, cn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, mn = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, fn = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, zr = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", hn = new RegExp(`^${zr}$`);
function Dr(r) {
  let e = "[0-5]\\d";
  r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = r.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function pn(r) {
  return new RegExp(`^${Dr(r)}$`);
}
function vn(r) {
  let e = `${zr}T${Dr(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function gn(r, e) {
  return !!((e === "v4" || !e) && dn.test(r) || (e === "v6" || !e) && ln.test(r));
}
function yn(r, e) {
  if (!rn.test(r))
    return !1;
  try {
    const [t] = r.split(".");
    if (!t)
      return !1;
    const a = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), n = JSON.parse(atob(a));
    return !(typeof n != "object" || n === null || "typ" in n && n?.typ !== "JWT" || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function _n(r, e) {
  return !!((e === "v4" || !e) && un.test(r) || (e === "v6" || !e) && cn.test(r));
}
let nt = class Oe extends z {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== y.string) {
      const n = this._getOrReturnCtx(e);
      return p(n, {
        code: m.invalid_type,
        expected: y.string,
        received: n.parsedType
      }), C;
    }
    const t = new B();
    let a;
    for (const n of this._def.checks)
      if (n.kind === "min")
        e.data.length < n.value && (a = this._getOrReturnCtx(e, a), p(a, {
          code: m.too_small,
          minimum: n.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: n.message
        }), t.dirty());
      else if (n.kind === "max")
        e.data.length > n.value && (a = this._getOrReturnCtx(e, a), p(a, {
          code: m.too_big,
          maximum: n.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: n.message
        }), t.dirty());
      else if (n.kind === "length") {
        const i = e.data.length > n.value, s = e.data.length < n.value;
        (i || s) && (a = this._getOrReturnCtx(e, a), i ? p(a, {
          code: m.too_big,
          maximum: n.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: n.message
        }) : s && p(a, {
          code: m.too_small,
          minimum: n.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: n.message
        }), t.dirty());
      } else if (n.kind === "email")
        sn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "email",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "emoji")
        Ge || (Ge = new RegExp(on, "u")), Ge.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "emoji",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "uuid")
        tn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "uuid",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "nanoid")
        an.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "nanoid",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "cuid")
        Gr.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "cuid",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "cuid2")
        Qr.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "cuid2",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "ulid")
        en.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
          validation: "ulid",
          code: m.invalid_string,
          message: n.message
        }), t.dirty());
      else if (n.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), p(a, {
            validation: "url",
            code: m.invalid_string,
            message: n.message
          }), t.dirty();
        }
      else n.kind === "regex" ? (n.regex.lastIndex = 0, n.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "regex",
        code: m.invalid_string,
        message: n.message
      }), t.dirty())) : n.kind === "trim" ? e.data = e.data.trim() : n.kind === "includes" ? e.data.includes(n.value, n.position) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: { includes: n.value, position: n.position },
        message: n.message
      }), t.dirty()) : n.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : n.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : n.kind === "startsWith" ? e.data.startsWith(n.value) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: { startsWith: n.value },
        message: n.message
      }), t.dirty()) : n.kind === "endsWith" ? e.data.endsWith(n.value) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: { endsWith: n.value },
        message: n.message
      }), t.dirty()) : n.kind === "datetime" ? vn(n).test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: "datetime",
        message: n.message
      }), t.dirty()) : n.kind === "date" ? hn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: "date",
        message: n.message
      }), t.dirty()) : n.kind === "time" ? pn(n).test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.invalid_string,
        validation: "time",
        message: n.message
      }), t.dirty()) : n.kind === "duration" ? nn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "duration",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : n.kind === "ip" ? gn(e.data, n.version) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "ip",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : n.kind === "jwt" ? yn(e.data, n.alg) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "jwt",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : n.kind === "cidr" ? _n(e.data, n.version) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "cidr",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : n.kind === "base64" ? mn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "base64",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : n.kind === "base64url" ? fn.test(e.data) || (a = this._getOrReturnCtx(e, a), p(a, {
        validation: "base64url",
        code: m.invalid_string,
        message: n.message
      }), t.dirty()) : D.assertNever(n);
    return { status: t.value, value: e.data };
  }
  _regex(e, t, a) {
    return this.refinement((n) => e.test(n), {
      validation: t,
      code: m.invalid_string,
      ...b.errToObj(a)
    });
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...b.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...b.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...b.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...b.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...b.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...b.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...b.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...b.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...b.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...b.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...b.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...b.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...b.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...b.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...b.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...b.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...b.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t?.position,
      ...b.errToObj(t?.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...b.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...b.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...b.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...b.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...b.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, b.errToObj(e));
  }
  trim() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
};
nt.create = (r) => new nt({
  checks: [],
  typeName: E.ZodString,
  coerce: r?.coerce ?? !1,
  ...A(r)
});
function bn(r, e) {
  const t = (r.toString().split(".")[1] || "").length, a = (e.toString().split(".")[1] || "").length, n = t > a ? t : a, i = Number.parseInt(r.toFixed(n).replace(".", "")), s = Number.parseInt(e.toFixed(n).replace(".", ""));
  return i % s / 10 ** n;
}
let rr = class it extends z {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== y.number) {
      const n = this._getOrReturnCtx(e);
      return p(n, {
        code: m.invalid_type,
        expected: y.number,
        received: n.parsedType
      }), C;
    }
    let t;
    const a = new B();
    for (const n of this._def.checks)
      n.kind === "int" ? D.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.invalid_type,
        expected: "integer",
        received: "float",
        message: n.message
      }), a.dirty()) : n.kind === "min" ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.too_small,
        minimum: n.value,
        type: "number",
        inclusive: n.inclusive,
        exact: !1,
        message: n.message
      }), a.dirty()) : n.kind === "max" ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.too_big,
        maximum: n.value,
        type: "number",
        inclusive: n.inclusive,
        exact: !1,
        message: n.message
      }), a.dirty()) : n.kind === "multipleOf" ? bn(e.data, n.value) !== 0 && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.not_multiple_of,
        multipleOf: n.value,
        message: n.message
      }), a.dirty()) : n.kind === "finite" ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.not_finite,
        message: n.message
      }), a.dirty()) : D.assertNever(n);
    return { status: a.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, b.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, b.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, b.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, b.toString(t));
  }
  setLimit(e, t, a, n) {
    return new it({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: a,
          message: b.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new it({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: b.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: b.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: b.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: b.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: b.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: b.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: b.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: b.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: b.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && D.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const a of this._def.checks) {
      if (a.kind === "finite" || a.kind === "int" || a.kind === "multipleOf")
        return !0;
      a.kind === "min" ? (t === null || a.value > t) && (t = a.value) : a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
};
rr.create = (r) => new rr({
  checks: [],
  typeName: E.ZodNumber,
  coerce: r?.coerce || !1,
  ...A(r)
});
class Ae extends z {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== y.bigint)
      return this._getInvalidInput(e);
    let t;
    const a = new B();
    for (const n of this._def.checks)
      n.kind === "min" ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.too_small,
        type: "bigint",
        minimum: n.value,
        inclusive: n.inclusive,
        message: n.message
      }), a.dirty()) : n.kind === "max" ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.too_big,
        type: "bigint",
        maximum: n.value,
        inclusive: n.inclusive,
        message: n.message
      }), a.dirty()) : n.kind === "multipleOf" ? e.data % n.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), p(t, {
        code: m.not_multiple_of,
        multipleOf: n.value,
        message: n.message
      }), a.dirty()) : D.assertNever(n);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return p(t, {
      code: m.invalid_type,
      expected: y.bigint,
      received: t.parsedType
    }), C;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, b.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, b.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, b.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, b.toString(t));
  }
  setLimit(e, t, a, n) {
    return new Ae({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: a,
          message: b.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ae({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: b.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: b.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: b.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: b.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: b.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Ae.create = (r) => new Ae({
  checks: [],
  typeName: E.ZodBigInt,
  coerce: r?.coerce ?? !1,
  ...A(r)
});
let nr = class extends z {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== y.boolean) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.boolean,
        received: t.parsedType
      }), C;
    }
    return q(e.data);
  }
};
nr.create = (r) => new nr({
  typeName: E.ZodBoolean,
  coerce: r?.coerce || !1,
  ...A(r)
});
let ir = class Zr extends z {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== y.date) {
      const n = this._getOrReturnCtx(e);
      return p(n, {
        code: m.invalid_type,
        expected: y.date,
        received: n.parsedType
      }), C;
    }
    if (Number.isNaN(e.data.getTime())) {
      const n = this._getOrReturnCtx(e);
      return p(n, {
        code: m.invalid_date
      }), C;
    }
    const t = new B();
    let a;
    for (const n of this._def.checks)
      n.kind === "min" ? e.data.getTime() < n.value && (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.too_small,
        message: n.message,
        inclusive: !0,
        exact: !1,
        minimum: n.value,
        type: "date"
      }), t.dirty()) : n.kind === "max" ? e.data.getTime() > n.value && (a = this._getOrReturnCtx(e, a), p(a, {
        code: m.too_big,
        message: n.message,
        inclusive: !0,
        exact: !1,
        maximum: n.value,
        type: "date"
      }), t.dirty()) : D.assertNever(n);
    return {
      status: t.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Zr({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: b.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: b.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
};
ir.create = (r) => new ir({
  checks: [],
  coerce: r?.coerce || !1,
  typeName: E.ZodDate,
  ...A(r)
});
let sr = class extends z {
  _parse(e) {
    if (this._getType(e) !== y.symbol) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.symbol,
        received: t.parsedType
      }), C;
    }
    return q(e.data);
  }
};
sr.create = (r) => new sr({
  typeName: E.ZodSymbol,
  ...A(r)
});
let or = class extends z {
  _parse(e) {
    if (this._getType(e) !== y.undefined) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.undefined,
        received: t.parsedType
      }), C;
    }
    return q(e.data);
  }
};
or.create = (r) => new or({
  typeName: E.ZodUndefined,
  ...A(r)
});
let dr = class extends z {
  _parse(e) {
    if (this._getType(e) !== y.null) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.null,
        received: t.parsedType
      }), C;
    }
    return q(e.data);
  }
};
dr.create = (r) => new dr({
  typeName: E.ZodNull,
  ...A(r)
});
let ur = class extends z {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return q(e.data);
  }
};
ur.create = (r) => new ur({
  typeName: E.ZodAny,
  ...A(r)
});
let lr = class extends z {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return q(e.data);
  }
};
lr.create = (r) => new lr({
  typeName: E.ZodUnknown,
  ...A(r)
});
let ue = class extends z {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return p(t, {
      code: m.invalid_type,
      expected: y.never,
      received: t.parsedType
    }), C;
  }
};
ue.create = (r) => new ue({
  typeName: E.ZodNever,
  ...A(r)
});
let cr = class extends z {
  _parse(e) {
    if (this._getType(e) !== y.undefined) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.void,
        received: t.parsedType
      }), C;
    }
    return q(e.data);
  }
};
cr.create = (r) => new cr({
  typeName: E.ZodVoid,
  ...A(r)
});
let _e = class $e extends z {
  _parse(e) {
    const { ctx: t, status: a } = this._processInputParams(e), n = this._def;
    if (t.parsedType !== y.array)
      return p(t, {
        code: m.invalid_type,
        expected: y.array,
        received: t.parsedType
      }), C;
    if (n.exactLength !== null) {
      const s = t.data.length > n.exactLength.value, o = t.data.length < n.exactLength.value;
      (s || o) && (p(t, {
        code: s ? m.too_big : m.too_small,
        minimum: o ? n.exactLength.value : void 0,
        maximum: s ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), a.dirty());
    }
    if (n.minLength !== null && t.data.length < n.minLength.value && (p(t, {
      code: m.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), a.dirty()), n.maxLength !== null && t.data.length > n.maxLength.value && (p(t, {
      code: m.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), a.dirty()), t.common.async)
      return Promise.all([...t.data].map((s, o) => n.type._parseAsync(new de(t, s, t.path, o)))).then((s) => B.mergeArray(a, s));
    const i = [...t.data].map((s, o) => n.type._parseSync(new de(t, s, t.path, o)));
    return B.mergeArray(a, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new $e({
      ...this._def,
      minLength: { value: e, message: b.toString(t) }
    });
  }
  max(e, t) {
    return new $e({
      ...this._def,
      maxLength: { value: e, message: b.toString(t) }
    });
  }
  length(e, t) {
    return new $e({
      ...this._def,
      exactLength: { value: e, message: b.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
_e.create = (r, e) => new _e({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: E.ZodArray,
  ...A(e)
});
function ve(r) {
  if (r instanceof ae) {
    const e = {};
    for (const t in r.shape) {
      const a = r.shape[t];
      e[t] = se.create(ve(a));
    }
    return new ae({
      ...r._def,
      shape: () => e
    });
  } else return r instanceof _e ? new _e({
    ...r._def,
    type: ve(r.element)
  }) : r instanceof se ? se.create(ve(r.unwrap())) : r instanceof xe ? xe.create(ve(r.unwrap())) : r instanceof Ne ? Ne.create(r.items.map((e) => ve(e))) : r;
}
let ae = class J extends z {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = D.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== y.object) {
      const d = this._getOrReturnCtx(e);
      return p(d, {
        code: m.invalid_type,
        expected: y.object,
        received: d.parsedType
      }), C;
    }
    const { status: t, ctx: a } = this._processInputParams(e), { shape: n, keys: i } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof ue && this._def.unknownKeys === "strip"))
      for (const d in a.data)
        i.includes(d) || s.push(d);
    const o = [];
    for (const d of i) {
      const u = n[d], l = a.data[d];
      o.push({
        key: { status: "valid", value: d },
        value: u._parse(new de(a, l, a.path, d)),
        alwaysSet: d in a.data
      });
    }
    if (this._def.catchall instanceof ue) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const u of s)
          o.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (d === "strict")
        s.length > 0 && (p(a, {
          code: m.unrecognized_keys,
          keys: s
        }), t.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const u of s) {
        const l = a.data[u];
        o.push({
          key: { status: "valid", value: u },
          value: d._parse(
            new de(a, l, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const u of o) {
        const l = await u.key, f = await u.value;
        d.push({
          key: l,
          value: f,
          alwaysSet: u.alwaysSet
        });
      }
      return d;
    }).then((d) => B.mergeObjectSync(t, d)) : B.mergeObjectSync(t, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return b.errToObj, new J({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, a) => {
          var n, i;
          const s = ((i = (n = this._def).errorMap) == null ? void 0 : i.call(n, t, a).message) ?? a.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: b.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new J({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new J({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new J({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new J({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: E.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new J({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const a of D.objectKeys(e))
      e[a] && this.shape[a] && (t[a] = this.shape[a]);
    return new J({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const a of D.objectKeys(this.shape))
      e[a] || (t[a] = this.shape[a]);
    return new J({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ve(this);
  }
  partial(e) {
    const t = {};
    for (const a of D.objectKeys(this.shape)) {
      const n = this.shape[a];
      e && !e[a] ? t[a] = n : t[a] = n.optional();
    }
    return new J({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const a of D.objectKeys(this.shape))
      if (e && !e[a])
        t[a] = this.shape[a];
      else {
        let n = this.shape[a];
        for (; n instanceof se; )
          n = n._def.innerType;
        t[a] = n;
      }
    return new J({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Rr(D.objectKeys(this.shape));
  }
};
ae.create = (r, e) => new ae({
  shape: () => r,
  unknownKeys: "strip",
  catchall: ue.create(),
  typeName: E.ZodObject,
  ...A(e)
});
ae.strictCreate = (r, e) => new ae({
  shape: () => r,
  unknownKeys: "strict",
  catchall: ue.create(),
  typeName: E.ZodObject,
  ...A(e)
});
ae.lazycreate = (r, e) => new ae({
  shape: r,
  unknownKeys: "strip",
  catchall: ue.create(),
  typeName: E.ZodObject,
  ...A(e)
});
let He = class extends z {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = this._def.options;
    function n(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const s = i.map((o) => new ce(o.ctx.common.issues));
      return p(t, {
        code: m.invalid_union,
        unionErrors: s
      }), C;
    }
    if (t.common.async)
      return Promise.all(a.map(async (i) => {
        const s = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: s
          }),
          ctx: s
        };
      })).then(n);
    {
      let i;
      const s = [];
      for (const d of a) {
        const u = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, l = d._parseSync({
          data: t.data,
          path: t.path,
          parent: u
        });
        if (l.status === "valid")
          return l;
        l.status === "dirty" && !i && (i = { result: l, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const o = s.map((d) => new ce(d));
      return p(t, {
        code: m.invalid_union,
        unionErrors: o
      }), C;
    }
  }
  get options() {
    return this._def.options;
  }
};
He.create = (r, e) => new He({
  options: r,
  typeName: E.ZodUnion,
  ...A(e)
});
function st(r, e) {
  const t = ne(r), a = ne(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === y.object && a === y.object) {
    const n = D.objectKeys(e), i = D.objectKeys(r).filter((o) => n.indexOf(o) !== -1), s = { ...r, ...e };
    for (const o of i) {
      const d = st(r[o], e[o]);
      if (!d.valid)
        return { valid: !1 };
      s[o] = d.data;
    }
    return { valid: !0, data: s };
  } else if (t === y.array && a === y.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let i = 0; i < r.length; i++) {
      const s = r[i], o = e[i], d = st(s, o);
      if (!d.valid)
        return { valid: !1 };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  } else return t === y.date && a === y.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
let Ie = class extends z {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e), n = (i, s) => {
      if (er(i) || er(s))
        return C;
      const o = st(i.value, s.value);
      return o.valid ? ((tr(i) || tr(s)) && t.dirty(), { status: t.value, value: o.data }) : (p(a, {
        code: m.invalid_intersection_types
      }), C);
    };
    return a.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      }),
      this._def.right._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      })
    ]).then(([i, s]) => n(i, s)) : n(this._def.left._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }), this._def.right._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }));
  }
};
Ie.create = (r, e, t) => new Ie({
  left: r,
  right: e,
  typeName: E.ZodIntersection,
  ...A(t)
});
let Ne = class $r extends z {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== y.array)
      return p(a, {
        code: m.invalid_type,
        expected: y.array,
        received: a.parsedType
      }), C;
    if (a.data.length < this._def.items.length)
      return p(a, {
        code: m.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), C;
    !this._def.rest && a.data.length > this._def.items.length && (p(a, {
      code: m.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const n = [...a.data].map((i, s) => {
      const o = this._def.items[s] || this._def.rest;
      return o ? o._parse(new de(a, i, a.path, s)) : null;
    }).filter((i) => !!i);
    return a.common.async ? Promise.all(n).then((i) => B.mergeArray(t, i)) : B.mergeArray(t, n);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new $r({
      ...this._def,
      rest: e
    });
  }
};
Ne.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ne({
    items: r,
    typeName: E.ZodTuple,
    rest: null,
    ...A(e)
  });
};
let mr = class extends z {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== y.map)
      return p(a, {
        code: m.invalid_type,
        expected: y.map,
        received: a.parsedType
      }), C;
    const n = this._def.keyType, i = this._def.valueType, s = [...a.data.entries()].map(([o, d], u) => ({
      key: n._parse(new de(a, o, a.path, [u, "key"])),
      value: i._parse(new de(a, d, a.path, [u, "value"]))
    }));
    if (a.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of s) {
          const u = await d.key, l = await d.value;
          if (u.status === "aborted" || l.status === "aborted")
            return C;
          (u.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(u.value, l.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of s) {
        const u = d.key, l = d.value;
        if (u.status === "aborted" || l.status === "aborted")
          return C;
        (u.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(u.value, l.value);
      }
      return { status: t.value, value: o };
    }
  }
};
mr.create = (r, e, t) => new mr({
  valueType: e,
  keyType: r,
  typeName: E.ZodMap,
  ...A(t)
});
let fr = class ot extends z {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== y.set)
      return p(a, {
        code: m.invalid_type,
        expected: y.set,
        received: a.parsedType
      }), C;
    const n = this._def;
    n.minSize !== null && a.data.size < n.minSize.value && (p(a, {
      code: m.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), t.dirty()), n.maxSize !== null && a.data.size > n.maxSize.value && (p(a, {
      code: m.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function s(d) {
      const u = /* @__PURE__ */ new Set();
      for (const l of d) {
        if (l.status === "aborted")
          return C;
        l.status === "dirty" && t.dirty(), u.add(l.value);
      }
      return { status: t.value, value: u };
    }
    const o = [...a.data.values()].map((d, u) => i._parse(new de(a, d, a.path, u)));
    return a.common.async ? Promise.all(o).then((d) => s(d)) : s(o);
  }
  min(e, t) {
    return new ot({
      ...this._def,
      minSize: { value: e, message: b.toString(t) }
    });
  }
  max(e, t) {
    return new ot({
      ...this._def,
      maxSize: { value: e, message: b.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
fr.create = (r, e) => new fr({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: E.ZodSet,
  ...A(e)
});
let hr = class extends z {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
};
hr.create = (r, e) => new hr({
  getter: r,
  typeName: E.ZodLazy,
  ...A(e)
});
let pr = class extends z {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        received: t.data,
        code: m.invalid_literal,
        expected: this._def.value
      }), C;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
pr.create = (r, e) => new pr({
  value: r,
  typeName: E.ZodLiteral,
  ...A(e)
});
function Rr(r, e) {
  return new Ua({
    values: r,
    typeName: E.ZodEnum,
    ...A(e)
  });
}
let Ua = class dt extends z {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), a = this._def.values;
      return p(t, {
        expected: D.joinValues(a),
        received: t.parsedType,
        code: m.invalid_type
      }), C;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), a = this._def.values;
      return p(t, {
        received: t.data,
        code: m.invalid_enum_value,
        options: a
      }), C;
    }
    return q(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return dt.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return dt.create(this.options.filter((a) => !e.includes(a)), {
      ...this._def,
      ...t
    });
  }
};
Ua.create = Rr;
let vr = class extends z {
  _parse(e) {
    const t = D.getValidEnumValues(this._def.values), a = this._getOrReturnCtx(e);
    if (a.parsedType !== y.string && a.parsedType !== y.number) {
      const n = D.objectValues(t);
      return p(a, {
        expected: D.joinValues(n),
        received: a.parsedType,
        code: m.invalid_type
      }), C;
    }
    if (this._cache || (this._cache = new Set(D.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const n = D.objectValues(t);
      return p(a, {
        received: a.data,
        code: m.invalid_enum_value,
        options: n
      }), C;
    }
    return q(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
vr.create = (r, e) => new vr({
  values: r,
  typeName: E.ZodNativeEnum,
  ...A(e)
});
let Fe = class extends z {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== y.promise && t.common.async === !1)
      return p(t, {
        code: m.invalid_type,
        expected: y.promise,
        received: t.parsedType
      }), C;
    const a = t.parsedType === y.promise ? t.data : Promise.resolve(t.data);
    return q(a.then((n) => this._def.type.parseAsync(n, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
};
Fe.create = (r, e) => new Fe({
  type: r,
  typeName: E.ZodPromise,
  ...A(e)
});
let be = class extends z {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === E.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e), n = this._def.effect || null, i = {
      addIssue: (s) => {
        p(a, s), s.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return a.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), n.type === "preprocess") {
      const s = n.transform(a.data, i);
      if (a.common.async)
        return Promise.resolve(s).then(async (o) => {
          if (t.value === "aborted")
            return C;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: a.path,
            parent: a
          });
          return d.status === "aborted" ? C : d.status === "dirty" || t.value === "dirty" ? rt(d.value) : d;
        });
      {
        if (t.value === "aborted")
          return C;
        const o = this._def.schema._parseSync({
          data: s,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? C : o.status === "dirty" || t.value === "dirty" ? rt(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const s = (o) => {
        const d = n.refinement(o, i);
        if (a.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (a.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? C : (o.status === "dirty" && t.dirty(), s(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((o) => o.status === "aborted" ? C : (o.status === "dirty" && t.dirty(), s(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (n.type === "transform")
      if (a.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        if (!ye(s))
          return C;
        const o = n.transform(s.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((s) => ye(s) ? Promise.resolve(n.transform(s.value, i)).then((o) => ({
          status: t.value,
          value: o
        })) : C);
    D.assertNever(n);
  }
};
be.create = (r, e, t) => new be({
  schema: r,
  typeName: E.ZodEffects,
  effect: e,
  ...A(t)
});
be.createWithPreprocess = (r, e, t) => new be({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: E.ZodEffects,
  ...A(t)
});
let se = class extends z {
  _parse(e) {
    return this._getType(e) === y.undefined ? q(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
se.create = (r, e) => new se({
  innerType: r,
  typeName: E.ZodOptional,
  ...A(e)
});
let xe = class extends z {
  _parse(e) {
    return this._getType(e) === y.null ? q(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
xe.create = (r, e) => new xe({
  innerType: r,
  typeName: E.ZodNullable,
  ...A(e)
});
let ut = class extends z {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let a = t.data;
    return t.parsedType === y.undefined && (a = this._def.defaultValue()), this._def.innerType._parse({
      data: a,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ut.create = (r, e) => new ut({
  innerType: r,
  typeName: E.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...A(e)
});
let lt = class extends z {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: a.data,
      path: a.path,
      parent: {
        ...a
      }
    });
    return Re(n) ? n.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ce(a.common.issues);
        },
        input: a.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new ce(a.common.issues);
        },
        input: a.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
lt.create = (r, e) => new lt({
  innerType: r,
  typeName: E.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...A(e)
});
let gr = class extends z {
  _parse(e) {
    if (this._getType(e) !== y.nan) {
      const t = this._getOrReturnCtx(e);
      return p(t, {
        code: m.invalid_type,
        expected: y.nan,
        received: t.parsedType
      }), C;
    }
    return { status: "valid", value: e.data };
  }
};
gr.create = (r) => new gr({
  typeName: E.ZodNaN,
  ...A(r)
});
let xn = class extends z {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = t.data;
    return this._def.type._parse({
      data: a,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}, Mn = class Hr extends z {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.common.async)
      return (async () => {
        const n = await this._def.in._parseAsync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return n.status === "aborted" ? C : n.status === "dirty" ? (t.dirty(), rt(n.value)) : this._def.out._parseAsync({
          data: n.value,
          path: a.path,
          parent: a
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: a.data,
        path: a.path,
        parent: a
      });
      return n.status === "aborted" ? C : n.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: a.path,
        parent: a
      });
    }
  }
  static create(e, t) {
    return new Hr({
      in: e,
      out: t,
      typeName: E.ZodPipeline
    });
  }
}, ct = class extends z {
  _parse(e) {
    const t = this._def.innerType._parse(e), a = (n) => (ye(n) && (n.value = Object.freeze(n.value)), n);
    return Re(t) ? t.then((n) => a(n)) : a(t);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ct.create = (r, e) => new ct({
  innerType: r,
  typeName: E.ZodReadonly,
  ...A(e)
});
var E;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(E || (E = {}));
const wn = nt.create;
ue.create;
_e.create;
const kn = ae.create;
He.create;
Ie.create;
Ne.create;
const Ja = Ua.create;
Fe.create;
se.create;
xe.create;
const Pn = "LOCALHOST", jn = "PROD", Sn = "STG", En = {
  LOCALHOST: Pn,
  PROD: jn,
  STG: Sn
}, Cn = "NATIVE", On = "SERVER", Tn = "WEB", An = {
  NATIVE: Cn,
  SERVER: On,
  WEB: Tn
}, Nn = "LOGIN", Wn = "PAYWALL", zn = {
  LOGIN: Nn,
  PAYWALL: Wn
}, Dn = Ja(
  Object.values(zn)
);
kn({
  componentTag: wn(),
  type: Dn
});
const Zn = Ja(
  Object.values(En)
), $n = Ja(Object.values(An));
var Z;
(function(r) {
  r.assertEqual = (n) => {
  };
  function e(n) {
  }
  r.assertIs = e;
  function t(n) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (n) => {
    const i = {};
    for (const s of n)
      i[s] = s;
    return i;
  }, r.getValidEnumValues = (n) => {
    const i = r.objectKeys(n).filter((o) => typeof n[n[o]] != "number"), s = {};
    for (const o of i)
      s[o] = n[o];
    return r.objectValues(s);
  }, r.objectValues = (n) => r.objectKeys(n).map(function(i) {
    return n[i];
  }), r.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const i = [];
    for (const s in n)
      Object.prototype.hasOwnProperty.call(n, s) && i.push(s);
    return i;
  }, r.find = (n, i) => {
    for (const s of n)
      if (i(s))
        return s;
  }, r.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n;
  function a(n, i = " | ") {
    return n.map((s) => typeof s == "string" ? `'${s}'` : s).join(i);
  }
  r.joinValues = a, r.jsonStringifyReplacer = (n, i) => typeof i == "bigint" ? i.toString() : i;
})(Z || (Z = {}));
var yr;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(yr || (yr = {}));
const g = Z.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ie = (r) => {
  switch (typeof r) {
    case "undefined":
      return g.undefined;
    case "string":
      return g.string;
    case "number":
      return Number.isNaN(r) ? g.nan : g.number;
    case "boolean":
      return g.boolean;
    case "function":
      return g.function;
    case "bigint":
      return g.bigint;
    case "symbol":
      return g.symbol;
    case "object":
      return Array.isArray(r) ? g.array : r === null ? g.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? g.promise : typeof Map < "u" && r instanceof Map ? g.map : typeof Set < "u" && r instanceof Set ? g.set : typeof Date < "u" && r instanceof Date ? g.date : g.object;
    default:
      return g.unknown;
  }
}, c = Z.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class re extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (a) => {
      this.issues = [...this.issues, a];
    }, this.addIssues = (a = []) => {
      this.issues = [...this.issues, ...a];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, a = { _errors: [] }, n = (i) => {
      for (const s of i.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(n);
        else if (s.code === "invalid_return_type")
          n(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          n(s.argumentsError);
        else if (s.path.length === 0)
          a._errors.push(t(s));
        else {
          let o = a, d = 0;
          for (; d < s.path.length; ) {
            const u = s.path[d];
            d === s.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(t(s))) : o[u] = o[u] || { _errors: [] }, o = o[u], d++;
          }
        }
    };
    return n(this), a;
  }
  static assert(e) {
    if (!(e instanceof re))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Z.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, a = [];
    for (const n of this.issues)
      if (n.path.length > 0) {
        const i = n.path[0];
        t[i] = t[i] || [], t[i].push(e(n));
      } else
        a.push(e(n));
    return { formErrors: a, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
re.create = (r) => new re(r);
const mt = (r, e) => {
  let t;
  switch (r.code) {
    case c.invalid_type:
      r.received === g.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case c.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, Z.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${Z.joinValues(r.keys, ", ")}`;
      break;
    case c.invalid_union:
      t = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${Z.joinValues(r.options)}`;
      break;
    case c.invalid_enum_value:
      t = `Invalid enum value. Expected ${Z.joinValues(r.options)}, received '${r.received}'`;
      break;
    case c.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      t = "Invalid function return type";
      break;
    case c.invalid_date:
      t = "Invalid date";
      break;
    case c.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : Z.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case c.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "bigint" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case c.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case c.custom:
      t = "Invalid input";
      break;
    case c.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case c.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, Z.assertNever(r);
  }
  return { message: t };
};
let Rn = mt;
function Hn() {
  return Rn;
}
const In = (r) => {
  const { data: e, path: t, errorMaps: a, issueData: n } = r, i = [...t, ...n.path || []], s = {
    ...n,
    path: i
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: i,
      message: n.message
    };
  let o = "";
  const d = a.filter((u) => !!u).slice().reverse();
  for (const u of d)
    o = u(s, { data: e, defaultError: o }).message;
  return {
    ...n,
    path: i,
    message: o
  };
};
function h(r, e) {
  const t = Hn(), a = In({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === mt ? void 0 : mt
      // then global default map
    ].filter((n) => !!n)
  });
  r.common.issues.push(a);
}
class V {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const a = [];
    for (const n of t) {
      if (n.status === "aborted")
        return j;
      n.status === "dirty" && e.dirty(), a.push(n.value);
    }
    return { status: e.value, value: a };
  }
  static async mergeObjectAsync(e, t) {
    const a = [];
    for (const n of t) {
      const i = await n.key, s = await n.value;
      a.push({
        key: i,
        value: s
      });
    }
    return V.mergeObjectSync(e, a);
  }
  static mergeObjectSync(e, t) {
    const a = {};
    for (const n of t) {
      const { key: i, value: s } = n;
      if (i.status === "aborted" || s.status === "aborted")
        return j;
      i.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof s.value < "u" || n.alwaysSet) && (a[i.value] = s.value);
    }
    return { status: e.value, value: a };
  }
}
const j = Object.freeze({
  status: "aborted"
}), Te = (r) => ({ status: "dirty", value: r }), U = (r) => ({ status: "valid", value: r }), _r = (r) => r.status === "aborted", br = (r) => r.status === "dirty", Me = (r) => r.status === "valid", Le = (r) => typeof Promise < "u" && r instanceof Promise;
var x;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e?.message;
})(x || (x = {}));
class K {
  constructor(e, t, a, n) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = a, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const xr = (r, e) => {
  if (Me(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new re(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function O(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: a, description: n } = r;
  if (e && (t || a))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (s, o) => {
    const { message: d } = r;
    return s.code === "invalid_enum_value" ? { message: d ?? o.defaultError } : typeof o.data > "u" ? { message: d ?? a ?? o.defaultError } : s.code !== "invalid_type" ? { message: o.defaultError } : { message: d ?? t ?? o.defaultError };
  }, description: n };
}
class W {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return ie(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: ie(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new V(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: ie(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Le(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const a = this.safeParse(e, t);
    if (a.success)
      return a.data;
    throw a.error;
  }
  safeParse(e, t) {
    const a = {
      common: {
        issues: [],
        async: t?.async ?? !1,
        contextualErrorMap: t?.errorMap
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ie(e)
    }, n = this._parseSync({ data: e, path: a.path, parent: a });
    return xr(a, n);
  }
  "~validate"(e) {
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ie(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: t });
        return Me(a) ? {
          value: a.value
        } : {
          issues: t.common.issues
        };
      } catch (a) {
        a?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((a) => Me(a) ? {
      value: a.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const a = await this.safeParseAsync(e, t);
    if (a.success)
      return a.data;
    throw a.error;
  }
  async safeParseAsync(e, t) {
    const a = {
      common: {
        issues: [],
        contextualErrorMap: t?.errorMap,
        async: !0
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ie(e)
    }, n = this._parse({ data: e, path: a.path, parent: a }), i = await (Le(n) ? n : Promise.resolve(n));
    return xr(a, i);
  }
  refine(e, t) {
    const a = (n) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(n) : t;
    return this._refinement((n, i) => {
      const s = e(n), o = () => i.addIssue({
        code: c.custom,
        ...a(n)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((d) => d ? !0 : (o(), !1)) : s ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((a, n) => e(a) ? !0 : (n.addIssue(typeof t == "function" ? t(a, n) : t), !1));
  }
  _refinement(e) {
    return new Pe({
      schema: this,
      typeName: P.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return oe.create(this, this._def);
  }
  nullable() {
    return je.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Y.create(this);
  }
  promise() {
    return Je.create(this, this._def);
  }
  or(e) {
    return Xe.create([this, e], this._def);
  }
  and(e) {
    return qe.create(this, e, this._def);
  }
  transform(e) {
    return new Pe({
      ...O(this._def),
      schema: this,
      typeName: P.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new vt({
      ...O(this._def),
      innerType: this,
      defaultValue: t,
      typeName: P.ZodDefault
    });
  }
  brand() {
    return new li({
      typeName: P.ZodBranded,
      type: this,
      ...O(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new gt({
      ...O(this._def),
      innerType: this,
      catchValue: t,
      typeName: P.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Ba.create(this, e);
  }
  readonly() {
    return yt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Fn = /^c[^\s-]{8,}$/i, Ln = /^[0-9a-z]+$/, Vn = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Xn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, qn = /^[a-z0-9_-]{21}$/i, Un = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Jn = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Bn = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Yn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Qe;
const Kn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Gn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Qn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ei = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ti = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ai = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ir = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", ri = new RegExp(`^${Ir}$`);
function Fr(r) {
  let e = "[0-5]\\d";
  r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = r.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function ni(r) {
  return new RegExp(`^${Fr(r)}$`);
}
function ii(r) {
  let e = `${Ir}T${Fr(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function si(r, e) {
  return !!((e === "v4" || !e) && Kn.test(r) || (e === "v6" || !e) && Qn.test(r));
}
function oi(r, e) {
  if (!Un.test(r))
    return !1;
  try {
    const [t] = r.split(".");
    if (!t)
      return !1;
    const a = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), n = JSON.parse(atob(a));
    return !(typeof n != "object" || n === null || "typ" in n && n?.typ !== "JWT" || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function di(r, e) {
  return !!((e === "v4" || !e) && Gn.test(r) || (e === "v6" || !e) && ei.test(r));
}
class te extends W {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== g.string) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: c.invalid_type,
        expected: g.string,
        received: i.parsedType
      }), j;
    }
    const a = new V();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (n = this._getOrReturnCtx(e, n), h(n, {
          code: c.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), a.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (n = this._getOrReturnCtx(e, n), h(n, {
          code: c.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), a.dirty());
      else if (i.kind === "length") {
        const s = e.data.length > i.value, o = e.data.length < i.value;
        (s || o) && (n = this._getOrReturnCtx(e, n), s ? h(n, {
          code: c.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && h(n, {
          code: c.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), a.dirty());
      } else if (i.kind === "email")
        Bn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "email",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "emoji")
        Qe || (Qe = new RegExp(Yn, "u")), Qe.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "emoji",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "uuid")
        Xn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "uuid",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "nanoid")
        qn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "nanoid",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "cuid")
        Fn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "cuid",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "cuid2")
        Ln.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "cuid2",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "ulid")
        Vn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
          validation: "ulid",
          code: c.invalid_string,
          message: i.message
        }), a.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), h(n, {
            validation: "url",
            code: c.invalid_string,
            message: i.message
          }), a.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "regex",
        code: c.invalid_string,
        message: i.message
      }), a.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), a.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), a.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), a.dirty()) : i.kind === "datetime" ? ii(i).test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: "datetime",
        message: i.message
      }), a.dirty()) : i.kind === "date" ? ri.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: "date",
        message: i.message
      }), a.dirty()) : i.kind === "time" ? ni(i).test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_string,
        validation: "time",
        message: i.message
      }), a.dirty()) : i.kind === "duration" ? Jn.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "duration",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : i.kind === "ip" ? si(e.data, i.version) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "ip",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : i.kind === "jwt" ? oi(e.data, i.alg) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "jwt",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : i.kind === "cidr" ? di(e.data, i.version) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "cidr",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : i.kind === "base64" ? ti.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "base64",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : i.kind === "base64url" ? ai.test(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        validation: "base64url",
        code: c.invalid_string,
        message: i.message
      }), a.dirty()) : Z.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _regex(e, t, a) {
    return this.refinement((n) => e.test(n), {
      validation: t,
      code: c.invalid_string,
      ...x.errToObj(a)
    });
  }
  _addCheck(e) {
    return new te({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...x.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...x.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...x.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...x.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...x.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...x.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...x.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...x.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...x.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...x.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...x.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...x.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...x.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...x.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...x.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...x.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...x.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t?.position,
      ...x.errToObj(t?.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...x.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...x.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...x.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...x.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...x.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, x.errToObj(e));
  }
  trim() {
    return new te({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new te({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new te({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
te.create = (r) => new te({
  checks: [],
  typeName: P.ZodString,
  coerce: r?.coerce ?? !1,
  ...O(r)
});
function ui(r, e) {
  const t = (r.toString().split(".")[1] || "").length, a = (e.toString().split(".")[1] || "").length, n = t > a ? t : a, i = Number.parseInt(r.toFixed(n).replace(".", "")), s = Number.parseInt(e.toFixed(n).replace(".", ""));
  return i % s / 10 ** n;
}
class we extends W {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== g.number) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: c.invalid_type,
        expected: g.number,
        received: i.parsedType
      }), j;
    }
    let a;
    const n = new V();
    for (const i of this._def.checks)
      i.kind === "int" ? Z.isInteger(e.data) || (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? ui(e.data, i.value) !== 0 && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.not_finite,
        message: i.message
      }), n.dirty()) : Z.assertNever(i);
    return { status: n.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, x.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, x.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, x.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, x.toString(t));
  }
  setLimit(e, t, a, n) {
    return new we({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: a,
          message: x.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new we({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: x.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: x.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: x.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: x.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: x.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: x.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: x.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: x.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: x.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Z.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const a of this._def.checks) {
      if (a.kind === "finite" || a.kind === "int" || a.kind === "multipleOf")
        return !0;
      a.kind === "min" ? (t === null || a.value > t) && (t = a.value) : a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
we.create = (r) => new we({
  checks: [],
  typeName: P.ZodNumber,
  coerce: r?.coerce || !1,
  ...O(r)
});
class We extends W {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== g.bigint)
      return this._getInvalidInput(e);
    let a;
    const n = new V();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (a = this._getOrReturnCtx(e, a), h(a, {
        code: c.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : Z.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return h(t, {
      code: c.invalid_type,
      expected: g.bigint,
      received: t.parsedType
    }), j;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, x.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, x.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, x.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, x.toString(t));
  }
  setLimit(e, t, a, n) {
    return new We({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: a,
          message: x.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new We({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: x.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: x.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: x.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: x.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: x.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
We.create = (r) => new We({
  checks: [],
  typeName: P.ZodBigInt,
  coerce: r?.coerce ?? !1,
  ...O(r)
});
class Mr extends W {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== g.boolean) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.boolean,
        received: a.parsedType
      }), j;
    }
    return U(e.data);
  }
}
Mr.create = (r) => new Mr({
  typeName: P.ZodBoolean,
  coerce: r?.coerce || !1,
  ...O(r)
});
class Ve extends W {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== g.date) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: c.invalid_type,
        expected: g.date,
        received: i.parsedType
      }), j;
    }
    if (Number.isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: c.invalid_date
      }), j;
    }
    const a = new V();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), a.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), a.dirty()) : Z.assertNever(i);
    return {
      status: a.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ve({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: x.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: x.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
Ve.create = (r) => new Ve({
  checks: [],
  coerce: r?.coerce || !1,
  typeName: P.ZodDate,
  ...O(r)
});
class wr extends W {
  _parse(e) {
    if (this._getType(e) !== g.symbol) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.symbol,
        received: a.parsedType
      }), j;
    }
    return U(e.data);
  }
}
wr.create = (r) => new wr({
  typeName: P.ZodSymbol,
  ...O(r)
});
class ft extends W {
  _parse(e) {
    if (this._getType(e) !== g.undefined) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.undefined,
        received: a.parsedType
      }), j;
    }
    return U(e.data);
  }
}
ft.create = (r) => new ft({
  typeName: P.ZodUndefined,
  ...O(r)
});
class kr extends W {
  _parse(e) {
    if (this._getType(e) !== g.null) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.null,
        received: a.parsedType
      }), j;
    }
    return U(e.data);
  }
}
kr.create = (r) => new kr({
  typeName: P.ZodNull,
  ...O(r)
});
class Pr extends W {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return U(e.data);
  }
}
Pr.create = (r) => new Pr({
  typeName: P.ZodAny,
  ...O(r)
});
class ht extends W {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return U(e.data);
  }
}
ht.create = (r) => new ht({
  typeName: P.ZodUnknown,
  ...O(r)
});
class le extends W {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return h(t, {
      code: c.invalid_type,
      expected: g.never,
      received: t.parsedType
    }), j;
  }
}
le.create = (r) => new le({
  typeName: P.ZodNever,
  ...O(r)
});
class jr extends W {
  _parse(e) {
    if (this._getType(e) !== g.undefined) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.void,
        received: a.parsedType
      }), j;
    }
    return U(e.data);
  }
}
jr.create = (r) => new jr({
  typeName: P.ZodVoid,
  ...O(r)
});
class Y extends W {
  _parse(e) {
    const { ctx: t, status: a } = this._processInputParams(e), n = this._def;
    if (t.parsedType !== g.array)
      return h(t, {
        code: c.invalid_type,
        expected: g.array,
        received: t.parsedType
      }), j;
    if (n.exactLength !== null) {
      const s = t.data.length > n.exactLength.value, o = t.data.length < n.exactLength.value;
      (s || o) && (h(t, {
        code: s ? c.too_big : c.too_small,
        minimum: o ? n.exactLength.value : void 0,
        maximum: s ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), a.dirty());
    }
    if (n.minLength !== null && t.data.length < n.minLength.value && (h(t, {
      code: c.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), a.dirty()), n.maxLength !== null && t.data.length > n.maxLength.value && (h(t, {
      code: c.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), a.dirty()), t.common.async)
      return Promise.all([...t.data].map((s, o) => n.type._parseAsync(new K(t, s, t.path, o)))).then((s) => V.mergeArray(a, s));
    const i = [...t.data].map((s, o) => n.type._parseSync(new K(t, s, t.path, o)));
    return V.mergeArray(a, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new Y({
      ...this._def,
      minLength: { value: e, message: x.toString(t) }
    });
  }
  max(e, t) {
    return new Y({
      ...this._def,
      maxLength: { value: e, message: x.toString(t) }
    });
  }
  length(e, t) {
    return new Y({
      ...this._def,
      exactLength: { value: e, message: x.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Y.create = (r, e) => new Y({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: P.ZodArray,
  ...O(e)
});
function ge(r) {
  if (r instanceof I) {
    const e = {};
    for (const t in r.shape) {
      const a = r.shape[t];
      e[t] = oe.create(ge(a));
    }
    return new I({
      ...r._def,
      shape: () => e
    });
  } else return r instanceof Y ? new Y({
    ...r._def,
    type: ge(r.element)
  }) : r instanceof oe ? oe.create(ge(r.unwrap())) : r instanceof je ? je.create(ge(r.unwrap())) : r instanceof me ? me.create(r.items.map((e) => ge(e))) : r;
}
class I extends W {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = Z.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== g.object) {
      const u = this._getOrReturnCtx(e);
      return h(u, {
        code: c.invalid_type,
        expected: g.object,
        received: u.parsedType
      }), j;
    }
    const { status: a, ctx: n } = this._processInputParams(e), { shape: i, keys: s } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof le && this._def.unknownKeys === "strip"))
      for (const u in n.data)
        s.includes(u) || o.push(u);
    const d = [];
    for (const u of s) {
      const l = i[u], f = n.data[u];
      d.push({
        key: { status: "valid", value: u },
        value: l._parse(new K(n, f, n.path, u)),
        alwaysSet: u in n.data
      });
    }
    if (this._def.catchall instanceof le) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const l of o)
          d.push({
            key: { status: "valid", value: l },
            value: { status: "valid", value: n.data[l] }
          });
      else if (u === "strict")
        o.length > 0 && (h(n, {
          code: c.unrecognized_keys,
          keys: o
        }), a.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const l of o) {
        const f = n.data[l];
        d.push({
          key: { status: "valid", value: l },
          value: u._parse(
            new K(n, f, n.path, l)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: l in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const l of d) {
        const f = await l.key, _ = await l.value;
        u.push({
          key: f,
          value: _,
          alwaysSet: l.alwaysSet
        });
      }
      return u;
    }).then((u) => V.mergeObjectSync(a, u)) : V.mergeObjectSync(a, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return x.errToObj, new I({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, a) => {
          const n = this._def.errorMap?.(t, a).message ?? a.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: x.errToObj(e).message ?? n
          } : {
            message: n
          };
        }
      } : {}
    });
  }
  strip() {
    return new I({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new I({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new I({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new I({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: P.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new I({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const a of Z.objectKeys(e))
      e[a] && this.shape[a] && (t[a] = this.shape[a]);
    return new I({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const a of Z.objectKeys(this.shape))
      e[a] || (t[a] = this.shape[a]);
    return new I({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ge(this);
  }
  partial(e) {
    const t = {};
    for (const a of Z.objectKeys(this.shape)) {
      const n = this.shape[a];
      e && !e[a] ? t[a] = n : t[a] = n.optional();
    }
    return new I({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const a of Z.objectKeys(this.shape))
      if (e && !e[a])
        t[a] = this.shape[a];
      else {
        let i = this.shape[a];
        for (; i instanceof oe; )
          i = i._def.innerType;
        t[a] = i;
      }
    return new I({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Lr(Z.objectKeys(this.shape));
  }
}
I.create = (r, e) => new I({
  shape: () => r,
  unknownKeys: "strip",
  catchall: le.create(),
  typeName: P.ZodObject,
  ...O(e)
});
I.strictCreate = (r, e) => new I({
  shape: () => r,
  unknownKeys: "strict",
  catchall: le.create(),
  typeName: P.ZodObject,
  ...O(e)
});
I.lazycreate = (r, e) => new I({
  shape: r,
  unknownKeys: "strip",
  catchall: le.create(),
  typeName: P.ZodObject,
  ...O(e)
});
class Xe extends W {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = this._def.options;
    function n(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const s = i.map((o) => new re(o.ctx.common.issues));
      return h(t, {
        code: c.invalid_union,
        unionErrors: s
      }), j;
    }
    if (t.common.async)
      return Promise.all(a.map(async (i) => {
        const s = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: s
          }),
          ctx: s
        };
      })).then(n);
    {
      let i;
      const s = [];
      for (const d of a) {
        const u = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, l = d._parseSync({
          data: t.data,
          path: t.path,
          parent: u
        });
        if (l.status === "valid")
          return l;
        l.status === "dirty" && !i && (i = { result: l, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const o = s.map((d) => new re(d));
      return h(t, {
        code: c.invalid_union,
        unionErrors: o
      }), j;
    }
  }
  get options() {
    return this._def.options;
  }
}
Xe.create = (r, e) => new Xe({
  options: r,
  typeName: P.ZodUnion,
  ...O(e)
});
function pt(r, e) {
  const t = ie(r), a = ie(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === g.object && a === g.object) {
    const n = Z.objectKeys(e), i = Z.objectKeys(r).filter((o) => n.indexOf(o) !== -1), s = { ...r, ...e };
    for (const o of i) {
      const d = pt(r[o], e[o]);
      if (!d.valid)
        return { valid: !1 };
      s[o] = d.data;
    }
    return { valid: !0, data: s };
  } else if (t === g.array && a === g.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let i = 0; i < r.length; i++) {
      const s = r[i], o = e[i], d = pt(s, o);
      if (!d.valid)
        return { valid: !1 };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  } else return t === g.date && a === g.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
class qe extends W {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e), n = (i, s) => {
      if (_r(i) || _r(s))
        return j;
      const o = pt(i.value, s.value);
      return o.valid ? ((br(i) || br(s)) && t.dirty(), { status: t.value, value: o.data }) : (h(a, {
        code: c.invalid_intersection_types
      }), j);
    };
    return a.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      }),
      this._def.right._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      })
    ]).then(([i, s]) => n(i, s)) : n(this._def.left._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }), this._def.right._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }));
  }
}
qe.create = (r, e, t) => new qe({
  left: r,
  right: e,
  typeName: P.ZodIntersection,
  ...O(t)
});
class me extends W {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== g.array)
      return h(a, {
        code: c.invalid_type,
        expected: g.array,
        received: a.parsedType
      }), j;
    if (a.data.length < this._def.items.length)
      return h(a, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), j;
    !this._def.rest && a.data.length > this._def.items.length && (h(a, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const i = [...a.data].map((s, o) => {
      const d = this._def.items[o] || this._def.rest;
      return d ? d._parse(new K(a, s, a.path, o)) : null;
    }).filter((s) => !!s);
    return a.common.async ? Promise.all(i).then((s) => V.mergeArray(t, s)) : V.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new me({
      ...this._def,
      rest: e
    });
  }
}
me.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new me({
    items: r,
    typeName: P.ZodTuple,
    rest: null,
    ...O(e)
  });
};
class Ue extends W {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== g.object)
      return h(a, {
        code: c.invalid_type,
        expected: g.object,
        received: a.parsedType
      }), j;
    const n = [], i = this._def.keyType, s = this._def.valueType;
    for (const o in a.data)
      n.push({
        key: i._parse(new K(a, o, a.path, o)),
        value: s._parse(new K(a, a.data[o], a.path, o)),
        alwaysSet: o in a.data
      });
    return a.common.async ? V.mergeObjectAsync(t, n) : V.mergeObjectSync(t, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, a) {
    return t instanceof W ? new Ue({
      keyType: e,
      valueType: t,
      typeName: P.ZodRecord,
      ...O(a)
    }) : new Ue({
      keyType: te.create(),
      valueType: e,
      typeName: P.ZodRecord,
      ...O(t)
    });
  }
}
class Sr extends W {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== g.map)
      return h(a, {
        code: c.invalid_type,
        expected: g.map,
        received: a.parsedType
      }), j;
    const n = this._def.keyType, i = this._def.valueType, s = [...a.data.entries()].map(([o, d], u) => ({
      key: n._parse(new K(a, o, a.path, [u, "key"])),
      value: i._parse(new K(a, d, a.path, [u, "value"]))
    }));
    if (a.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of s) {
          const u = await d.key, l = await d.value;
          if (u.status === "aborted" || l.status === "aborted")
            return j;
          (u.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(u.value, l.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of s) {
        const u = d.key, l = d.value;
        if (u.status === "aborted" || l.status === "aborted")
          return j;
        (u.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(u.value, l.value);
      }
      return { status: t.value, value: o };
    }
  }
}
Sr.create = (r, e, t) => new Sr({
  valueType: e,
  keyType: r,
  typeName: P.ZodMap,
  ...O(t)
});
class ze extends W {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.parsedType !== g.set)
      return h(a, {
        code: c.invalid_type,
        expected: g.set,
        received: a.parsedType
      }), j;
    const n = this._def;
    n.minSize !== null && a.data.size < n.minSize.value && (h(a, {
      code: c.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), t.dirty()), n.maxSize !== null && a.data.size > n.maxSize.value && (h(a, {
      code: c.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function s(d) {
      const u = /* @__PURE__ */ new Set();
      for (const l of d) {
        if (l.status === "aborted")
          return j;
        l.status === "dirty" && t.dirty(), u.add(l.value);
      }
      return { status: t.value, value: u };
    }
    const o = [...a.data.values()].map((d, u) => i._parse(new K(a, d, a.path, u)));
    return a.common.async ? Promise.all(o).then((d) => s(d)) : s(o);
  }
  min(e, t) {
    return new ze({
      ...this._def,
      minSize: { value: e, message: x.toString(t) }
    });
  }
  max(e, t) {
    return new ze({
      ...this._def,
      maxSize: { value: e, message: x.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ze.create = (r, e) => new ze({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: P.ZodSet,
  ...O(e)
});
class Er extends W {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Er.create = (r, e) => new Er({
  getter: r,
  typeName: P.ZodLazy,
  ...O(e)
});
class Cr extends W {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return h(t, {
        received: t.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), j;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Cr.create = (r, e) => new Cr({
  value: r,
  typeName: P.ZodLiteral,
  ...O(e)
});
function Lr(r, e) {
  return new ke({
    values: r,
    typeName: P.ZodEnum,
    ...O(e)
  });
}
class ke extends W {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), a = this._def.values;
      return h(t, {
        expected: Z.joinValues(a),
        received: t.parsedType,
        code: c.invalid_type
      }), j;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), a = this._def.values;
      return h(t, {
        received: t.data,
        code: c.invalid_enum_value,
        options: a
      }), j;
    }
    return U(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return ke.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return ke.create(this.options.filter((a) => !e.includes(a)), {
      ...this._def,
      ...t
    });
  }
}
ke.create = Lr;
class Or extends W {
  _parse(e) {
    const t = Z.getValidEnumValues(this._def.values), a = this._getOrReturnCtx(e);
    if (a.parsedType !== g.string && a.parsedType !== g.number) {
      const n = Z.objectValues(t);
      return h(a, {
        expected: Z.joinValues(n),
        received: a.parsedType,
        code: c.invalid_type
      }), j;
    }
    if (this._cache || (this._cache = new Set(Z.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const n = Z.objectValues(t);
      return h(a, {
        received: a.data,
        code: c.invalid_enum_value,
        options: n
      }), j;
    }
    return U(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Or.create = (r, e) => new Or({
  values: r,
  typeName: P.ZodNativeEnum,
  ...O(e)
});
class Je extends W {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== g.promise && t.common.async === !1)
      return h(t, {
        code: c.invalid_type,
        expected: g.promise,
        received: t.parsedType
      }), j;
    const a = t.parsedType === g.promise ? t.data : Promise.resolve(t.data);
    return U(a.then((n) => this._def.type.parseAsync(n, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
Je.create = (r, e) => new Je({
  type: r,
  typeName: P.ZodPromise,
  ...O(e)
});
class Pe extends W {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === P.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e), n = this._def.effect || null, i = {
      addIssue: (s) => {
        h(a, s), s.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return a.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), n.type === "preprocess") {
      const s = n.transform(a.data, i);
      if (a.common.async)
        return Promise.resolve(s).then(async (o) => {
          if (t.value === "aborted")
            return j;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: a.path,
            parent: a
          });
          return d.status === "aborted" ? j : d.status === "dirty" || t.value === "dirty" ? Te(d.value) : d;
        });
      {
        if (t.value === "aborted")
          return j;
        const o = this._def.schema._parseSync({
          data: s,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? j : o.status === "dirty" || t.value === "dirty" ? Te(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const s = (o) => {
        const d = n.refinement(o, i);
        if (a.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (a.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? j : (o.status === "dirty" && t.dirty(), s(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((o) => o.status === "aborted" ? j : (o.status === "dirty" && t.dirty(), s(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (n.type === "transform")
      if (a.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        if (!Me(s))
          return j;
        const o = n.transform(s.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((s) => Me(s) ? Promise.resolve(n.transform(s.value, i)).then((o) => ({
          status: t.value,
          value: o
        })) : j);
    Z.assertNever(n);
  }
}
Pe.create = (r, e, t) => new Pe({
  schema: r,
  typeName: P.ZodEffects,
  effect: e,
  ...O(t)
});
Pe.createWithPreprocess = (r, e, t) => new Pe({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: P.ZodEffects,
  ...O(t)
});
class oe extends W {
  _parse(e) {
    return this._getType(e) === g.undefined ? U(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
oe.create = (r, e) => new oe({
  innerType: r,
  typeName: P.ZodOptional,
  ...O(e)
});
class je extends W {
  _parse(e) {
    return this._getType(e) === g.null ? U(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
je.create = (r, e) => new je({
  innerType: r,
  typeName: P.ZodNullable,
  ...O(e)
});
class vt extends W {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let a = t.data;
    return t.parsedType === g.undefined && (a = this._def.defaultValue()), this._def.innerType._parse({
      data: a,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
vt.create = (r, e) => new vt({
  innerType: r,
  typeName: P.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...O(e)
});
class gt extends W {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: a.data,
      path: a.path,
      parent: {
        ...a
      }
    });
    return Le(n) ? n.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new re(a.common.issues);
        },
        input: a.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new re(a.common.issues);
        },
        input: a.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
gt.create = (r, e) => new gt({
  innerType: r,
  typeName: P.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...O(e)
});
class Tr extends W {
  _parse(e) {
    if (this._getType(e) !== g.nan) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: g.nan,
        received: a.parsedType
      }), j;
    }
    return { status: "valid", value: e.data };
  }
}
Tr.create = (r) => new Tr({
  typeName: P.ZodNaN,
  ...O(r)
});
class li extends W {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), a = t.data;
    return this._def.type._parse({
      data: a,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ba extends W {
  _parse(e) {
    const { status: t, ctx: a } = this._processInputParams(e);
    if (a.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return i.status === "aborted" ? j : i.status === "dirty" ? (t.dirty(), Te(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: a.path,
          parent: a
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: a.data,
        path: a.path,
        parent: a
      });
      return n.status === "aborted" ? j : n.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: a.path,
        parent: a
      });
    }
  }
  static create(e, t) {
    return new Ba({
      in: e,
      out: t,
      typeName: P.ZodPipeline
    });
  }
}
class yt extends W {
  _parse(e) {
    const t = this._def.innerType._parse(e), a = (n) => (Me(n) && (n.value = Object.freeze(n.value)), n);
    return Le(t) ? t.then((n) => a(n)) : a(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
yt.create = (r, e) => new yt({
  innerType: r,
  typeName: P.ZodReadonly,
  ...O(e)
});
var P;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(P || (P = {}));
const T = te.create, De = we.create, et = ft.create, ci = ht.create;
le.create;
const tt = Y.create, X = I.create, mi = Xe.create;
qe.create;
me.create;
const fi = Ue.create, Se = ke.create;
Je.create;
oe.create;
je.create;
function F(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var _t = { exports: {} }, Vr = { exports: {} };
(function(r) {
  function e(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  r.exports = e, r.exports.__esModule = !0, r.exports.default = r.exports;
})(Vr);
var w = Vr.exports, bt = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "om " + d : d + " siden" : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(bt, bt.exports);
var hi = bt.exports, xt = { exports: {} }, Mt = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(a) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = n.width ? String(n.width) : a.defaultWidth, s = a.formats[i] || a.formats[a.defaultWidth];
      return s;
    };
  }
  r.exports = e.default;
})(Mt, Mt.exports);
var L = Mt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(xt, xt.exports);
var pi = xt.exports, wt = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})(wt, wt.exports);
var vi = wt.exports, kt = { exports: {} }, Pt = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(a) {
    return function(n, i) {
      var s = i != null && i.context ? String(i.context) : "standalone", o;
      if (s === "formatting" && a.formattingValues) {
        var d = a.defaultFormattingWidth || a.defaultWidth, u = i != null && i.width ? String(i.width) : d;
        o = a.formattingValues[u] || a.formattingValues[d];
      } else {
        var l = a.defaultWidth, f = i != null && i.width ? String(i.width) : a.defaultWidth;
        o = a.values[f] || a.values[l];
      }
      var _ = a.argumentCallback ? a.argumentCallback(n) : n;
      return o[_];
    };
  }
  r.exports = e.default;
})(Pt, Pt.exports);
var G = Pt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, o = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, l = function(v, M) {
    var k = Number(v);
    return k + ".";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(kt, kt.exports);
var gi = kt.exports, jt = { exports: {} }, St = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(i) {
    return function(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = o.width, u = d && i.matchPatterns[d] || i.matchPatterns[i.defaultMatchWidth], l = s.match(u);
      if (!l)
        return null;
      var f = l[0], _ = d && i.parsePatterns[d] || i.parsePatterns[i.defaultParseWidth], v = Array.isArray(_) ? n(_, function(N) {
        return N.test(f);
      }) : a(_, function(N) {
        return N.test(f);
      }), M;
      M = i.valueCallback ? i.valueCallback(v) : v, M = o.valueCallback ? o.valueCallback(M) : M;
      var k = s.slice(f.length);
      return {
        value: M,
        rest: k
      };
    };
  }
  function a(i, s) {
    for (var o in i)
      if (i.hasOwnProperty(o) && s(i[o]))
        return o;
  }
  function n(i, s) {
    for (var o = 0; o < i.length; o++)
      if (s(i[o]))
        return o;
  }
  r.exports = e.default;
})(St, St.exports);
var Q = St.exports, Et = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(a) {
    return function(n) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(a.matchPattern);
      if (!s)
        return null;
      var o = s[0], d = n.match(a.parsePattern);
      if (!d)
        return null;
      var u = a.valueCallback ? a.valueCallback(d[0]) : d[0];
      u = i.valueCallback ? i.valueCallback(u) : u;
      var l = n.slice(o.length);
      return {
        value: u,
        rest: l
      };
    };
  }
  r.exports = e.default;
})(Et, Et.exports);
var ee = Et.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(\.)?/i, s = /\d+/i, o = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, d = {
    any: [/^f/i, /^(v|e)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, M = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, k = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(jt, jt.exports);
var yi = jt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(hi), n = t(pi), i = t(vi), s = t(gi), o = t(yi), d = {
    code: "da",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(_t, _t.exports);
var _i = _t.exports;
const bi = /* @__PURE__ */ F(_i);
var Ct = { exports: {} }, Ot = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, a = function(i, s, o) {
    var d, u = o != null && o.addSuffix ? t[i].withPreposition : t[i].standalone;
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + d : "vor " + d : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Ot, Ot.exports);
var xi = Ot.exports, Tt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Tt, Tt.exports);
var Mi = Tt.exports, At = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})(At, At.exports);
var wi = At.exports, Nt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, o = {
    narrow: s.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: s.wide
  }, d = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, u = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, l = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, f = function(M) {
    var k = Number(M);
    return k + ".";
  }, _ = {
    ordinalNumber: f,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(M) {
        return M - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      formattingValues: o,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: d,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, v = _;
  e.default = v, r.exports = e.default;
})(Nt, Nt.exports);
var ki = Nt.exports, Wt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(\.)?/i, s = /\d+/i, o = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, d = {
    any: [/^v/i, /^n/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, M = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, k = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, N = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "wide",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Wt, Wt.exports);
var Pi = Wt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(xi), n = t(Mi), i = t(wi), s = t(ki), o = t(Pi), d = {
    code: "de",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Ct, Ct.exports);
var ji = Ct.exports;
const Si = /* @__PURE__ */ F(ji);
var zt = { exports: {} }, Dt = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", s.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + d : d + " ago" : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Dt, Dt.exports);
var Ee = Dt.exports, Zt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Zt, Zt.exports);
var Ei = Zt.exports, $t = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})($t, $t.exports);
var fe = $t.exports, Rt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, o = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, l = function(v, M) {
    var k = Number(v), N = k % 100;
    if (N > 20 || N < 10)
      switch (N % 10) {
        case 1:
          return k + "st";
        case 2:
          return k + "nd";
        case 3:
          return k + "rd";
      }
    return k + "th";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(Rt, Rt.exports);
var he = Rt.exports, Ht = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(th|st|nd|rd)?/i, s = /\d+/i, o = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, d = {
    any: [/^b/i, /^(a|c)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, M = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, k = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Ht, Ht.exports);
var pe = Ht.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(Ei), i = t(fe), s = t(he), o = t(pe), d = {
    code: "en-AU",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(zt, zt.exports);
var Ci = zt.exports;
const Oi = /* @__PURE__ */ F(Ci);
var It = { exports: {} }, Ft = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", s.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + d : d + " ago" : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Ft, Ft.exports);
var Ti = Ft.exports, Lt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Lt, Lt.exports);
var Ai = Lt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(fe), n = t(he), i = t(pe), s = t(Ti), o = t(Ai), d = {
    code: "en-CA",
    formatDistance: s.default,
    formatLong: o.default,
    formatRelative: a.default,
    localize: n.default,
    match: i.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(It, It.exports);
var Ni = It.exports;
const Wi = /* @__PURE__ */ F(Ni);
var Vt = { exports: {} }, Xt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Xt, Xt.exports);
var zi = Xt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(fe), i = t(he), s = t(pe), o = t(zi), d = {
    code: "en-GB",
    formatDistance: a.default,
    formatLong: o.default,
    formatRelative: n.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Vt, Vt.exports);
var Di = Vt.exports;
const Zi = /* @__PURE__ */ F(Di);
var qt = { exports: {} }, Ut = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Ut, Ut.exports);
var $i = Ut.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(fe), i = t(he), s = t(pe), o = t($i), d = {
    code: "en-IN",
    formatDistance: a.default,
    formatLong: o.default,
    formatRelative: n.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(qt, qt.exports);
var Ri = qt.exports;
const Hi = /* @__PURE__ */ F(Ri);
var Jt = { exports: {} }, Bt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Bt, Bt.exports);
var Ii = Bt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(fe), i = t(he), s = t(pe), o = t(Ii), d = {
    code: "en-NZ",
    formatDistance: a.default,
    formatLong: o.default,
    formatRelative: n.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Jt, Jt.exports);
var Fi = Jt.exports;
const Li = /* @__PURE__ */ F(Fi);
var Yt = { exports: {} }, Kt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Kt, Kt.exports);
var Vi = Kt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(Vi), i = t(fe), s = t(he), o = t(pe), d = {
    code: "en-US",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Yt, Yt.exports);
var Xi = Yt.exports;
const qi = /* @__PURE__ */ F(Xi);
var Gt = { exports: {} }, Qt = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Qt, Qt.exports);
var Ui = Qt.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ee), n = t(fe), i = t(he), s = t(pe), o = t(Ui), d = {
    code: "en-ZA",
    formatDistance: a.default,
    formatLong: o.default,
    formatRelative: n.default,
    localize: i.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Gt, Gt.exports);
var Ji = Gt.exports;
const Bi = /* @__PURE__ */ F(Ji);
var ea = { exports: {} }, ta = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", s.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "en " + d : "hace " + d : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(ta, ta.exports);
var Yi = ta.exports, aa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(aa, aa.exports);
var Ki = aa.exports, ra = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, a = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(s, o, d, u) {
    return o.getUTCHours() !== 1 ? a[s] : t[s];
  }, i = n;
  e.default = i, r.exports = e.default;
})(ra, ra.exports);
var Gi = ra.exports, na = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, o = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, l = function(v, M) {
    var k = Number(v);
    return k + "º";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return Number(v) - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(na, na.exports);
var Qi = na.exports, ia = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(ee), n = t(Q), i = /^(\d+)(º)?/i, s = /\d+/i, o = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, _ = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, v = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, M = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, k = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, $ = {
    ordinalNumber: (0, a.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(ia, ia.exports);
var es = ia.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Yi), n = t(Ki), i = t(Gi), s = t(Qi), o = t(es), d = {
    code: "es",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(ea, ea.exports);
var ts = ea.exports;
const as = /* @__PURE__ */ F(ts);
var sa = { exports: {} }, oa = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "dans " + d : "il y a " + d : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(oa, oa.exports);
var rs = oa.exports, da = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(da, da.exports);
var ns = da.exports, ua = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})(ua, ua.exports);
var is = ua.exports, la = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, i = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, o = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, u = function(_, v) {
    var M = Number(_), k = v?.unit;
    if (M === 0)
      return "0";
    var N = ["year", "week", "hour", "minute", "second"], $;
    return M === 1 ? $ = k && N.includes(k) ? "ère" : "er" : $ = "ème", M + $;
  }, l = {
    ordinalNumber: u,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(_) {
        return _ - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide"
    })
  }, f = l;
  e.default = f, r.exports = e.default;
})(la, la.exports);
var ss = la.exports, ca = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(ième|ère|ème|er|e)?/i, s = /\d+/i, o = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, d = {
    any: [/^av/i, /^ap/i]
  }, u = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, M = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, k = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(ca, ca.exports);
var os = ca.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(rs), n = t(ns), i = t(is), s = t(ss), o = t(os), d = {
    code: "fr",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(sa, sa.exports);
var ds = sa.exports;
const us = /* @__PURE__ */ F(ds);
var ma = { exports: {} }, fa = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", s.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "tra " + d : d + " fa" : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(fa, fa.exports);
var ls = fa.exports, ha = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(ha, ha.exports);
var cs = ha.exports, pa = { exports: {} }, va = { exports: {} }, ga = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(a, n) {
    if (n.length < a)
      throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  r.exports = e.default;
})(ga, ga.exports);
var Ya = ga.exports, ya = { exports: {} }, _a = { exports: {} }, Xr = { exports: {} };
(function(r) {
  function e(t) {
    "@babel/helpers - typeof";
    return r.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, r.exports.__esModule = !0, r.exports.default = r.exports, e(t);
  }
  r.exports = e, r.exports.__esModule = !0, r.exports.default = r.exports;
})(Xr);
var ms = Xr.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = t(ms), n = t(Ya);
  function i(s) {
    (0, n.default)(1, arguments);
    var o = Object.prototype.toString.call(s);
    return s instanceof Date || (0, a.default)(s) === "object" && o === "[object Date]" ? new Date(s.getTime()) : typeof s == "number" || o === "[object Number]" ? new Date(s) : ((typeof s == "string" || o === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  r.exports = e.default;
})(_a, _a.exports);
var fs = _a.exports, ba = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  r.exports = e.default;
})(ba, ba.exports);
var hs = ba.exports, Ye = {};
Object.defineProperty(Ye, "__esModule", {
  value: !0
});
Ye.getDefaultOptions = ps;
Ye.setDefaultOptions = vs;
var qr = {};
function ps() {
  return qr;
}
function vs(r) {
  qr = r;
}
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = t(fs), n = t(Ya), i = t(hs), s = Ye;
  function o(d, u) {
    var l, f, _, v, M, k, N, $;
    (0, n.default)(1, arguments);
    var H = (0, s.getDefaultOptions)(), S = (0, i.default)((l = (f = (_ = (v = u?.weekStartsOn) !== null && v !== void 0 ? v : u == null || (M = u.locale) === null || M === void 0 || (k = M.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && _ !== void 0 ? _ : H.weekStartsOn) !== null && f !== void 0 ? f : (N = H.locale) === null || N === void 0 || ($ = N.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && l !== void 0 ? l : 0);
    if (!(S >= 0 && S <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var Ce = (0, a.default)(d), Ga = Ce.getUTCDay(), Jr = (Ga < S ? 7 : 0) + Ga - S;
    return Ce.setUTCDate(Ce.getUTCDate() - Jr), Ce.setUTCHours(0, 0, 0, 0), Ce;
  }
  r.exports = e.default;
})(ya, ya.exports);
var gs = ya.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = t(Ya), n = t(gs);
  function i(s, o, d) {
    (0, a.default)(2, arguments);
    var u = (0, n.default)(s, d), l = (0, n.default)(o, d);
    return u.getTime() === l.getTime();
  }
  r.exports = e.default;
})(va, va.exports);
var ys = va.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(ys), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function i(f) {
    switch (f) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[f] + " scorso alle' p";
    }
  }
  function s(f) {
    return "'" + n[f] + " alle' p";
  }
  function o(f) {
    switch (f) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[f] + " prossimo alle' p";
    }
  }
  var d = {
    lastWeek: function(f, _, v) {
      var M = f.getUTCDay();
      return (0, a.default)(f, _, v) ? s(M) : i(M);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(f, _, v) {
      var M = f.getUTCDay();
      return (0, a.default)(f, _, v) ? s(M) : o(M);
    },
    other: "P"
  }, u = function(f, _, v, M) {
    var k = d[f];
    return typeof k == "function" ? k(_, v, M) : k;
  }, l = u;
  e.default = l, r.exports = e.default;
})(pa, pa.exports);
var _s = pa.exports, xa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, o = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, d = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, u = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, l = function(v, M) {
    var k = Number(v);
    return String(k);
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(xa, xa.exports);
var bs = xa.exports, Ma = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(º)?/i, s = /\d+/i, o = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, d = {
    any: [/^a/i, /^(d|e)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, _ = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, M = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, k = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Ma, Ma.exports);
var xs = Ma.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(ls), n = t(cs), i = t(_s), s = t(bs), o = t(xs), d = {
    code: "it",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(ma, ma.exports);
var Ms = ma.exports;
const ws = /* @__PURE__ */ F(Ms);
var wa = { exports: {} }, ka = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "over " + d : d + " geleden" : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(ka, ka.exports);
var ks = ka.exports, Pa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Pa, Pa.exports);
var Ps = Pa.exports, ja = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})(ja, ja.exports);
var js = ja.exports, Sa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, o = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, u = function(_, v) {
    var M = Number(_);
    return M + "e";
  }, l = {
    ordinalNumber: u,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(_) {
        return _ - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide"
    })
  }, f = l;
  e.default = f, r.exports = e.default;
})(Sa, Sa.exports);
var Ss = Sa.exports, Ea = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)e?/i, s = /\d+/i, o = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, d = {
    any: [/^v/, /^n/]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, v = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, M = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, k = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, N = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Ea, Ea.exports);
var Es = Ea.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(ks), n = t(Ps), i = t(js), s = t(Ss), o = t(Es), d = {
    code: "nl",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(wa, wa.exports);
var Cs = wa.exports;
const Os = /* @__PURE__ */ F(Cs);
var Ca = { exports: {} }, Oa = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "daqui a " + d : "há " + d : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Oa, Oa.exports);
var Ts = Oa.exports, Ta = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Ta, Ta.exports);
var As = Ta.exports, Aa = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: function(i) {
      var s = i.getUTCDay(), o = s === 0 || s === 6 ? "último" : "última";
      return "'" + o + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(i, s, o, d) {
    var u = t[i];
    return typeof u == "function" ? u(s) : u;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Aa, Aa.exports);
var Ns = Aa.exports, Na = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, o = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, d = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, u = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, l = function(v, M) {
    var k = Number(v);
    return k + "º";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(Na, Na.exports);
var Ws = Na.exports, Wa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(º|ª)?/i, s = /\d+/i, o = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, M = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, k = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Wa, Wa.exports);
var zs = Wa.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Ts), n = t(As), i = t(Ns), s = t(Ws), o = t(zs), d = {
    code: "pt",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Ca, Ca.exports);
var Ds = Ca.exports;
const Zs = /* @__PURE__ */ F(Ds);
var za = { exports: {} }, Da = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(i, s, o) {
    var d, u = t[i];
    return typeof u == "string" ? d = u : s === 1 ? d = u.one : d = u.other.replace("{{count}}", String(s)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "em " + d : "há " + d : d;
  }, n = a;
  e.default = n, r.exports = e.default;
})(Da, Da.exports);
var $s = Da.exports, Za = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, i = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(Za, Za.exports);
var Rs = Za.exports, $a = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: function(i) {
      var s = i.getUTCDay(), o = s === 0 || s === 6 ? "último" : "última";
      return "'" + o + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(i, s, o, d) {
    var u = t[i];
    return typeof u == "function" ? u(s) : u;
  }, n = a;
  e.default = n, r.exports = e.default;
})($a, $a.exports);
var Hs = $a.exports, Ra = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, o = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, l = function(v, M) {
    var k = Number(v);
    return M?.unit === "week" ? k + "ª" : k + "º";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(Ra, Ra.exports);
var Is = Ra.exports, Ha = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)[ºªo]?/i, s = /\d+/i, o = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, d = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, v = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, M = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, k = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, N = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(Ha, Ha.exports);
var Fs = Ha.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t($s), n = t(Rs), i = t(Hs), s = t(Is), o = t(Fs), d = {
    code: "pt-BR",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(za, za.exports);
var Ls = za.exports;
const Vs = /* @__PURE__ */ F(Ls);
var Ia = { exports: {} }, Fa = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, a = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(s, o, d) {
    var u, l = t[s];
    return typeof l == "string" ? u = l : o === 1 ? u = l.one : d && d.onlyNumeric ? u = l.other.replace("{{count}}", String(o)) : u = l.other.replace("{{count}}", o < 13 ? a[o] : String(o)), d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "om " + u : u + " sedan" : u;
  }, i = n;
  e.default = i, r.exports = e.default;
})(Fa, Fa.exports);
var Xs = Fa.exports, La = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(L), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, i = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, o = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, d = o;
  e.default = d, r.exports = e.default;
})(La, La.exports);
var qs = La.exports, Va = { exports: {} };
(function(r, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, a = function(i, s, o, d) {
    return t[i];
  }, n = a;
  e.default = n, r.exports = e.default;
})(Va, Va.exports);
var Us = Va.exports, Xa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(G), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, o = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, d = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, u = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, l = function(v, M) {
    var k = Number(v), N = k % 100;
    if (N > 20 || N < 10)
      switch (N % 10) {
        case 1:
        case 2:
          return k + ":a";
      }
    return k + ":e";
  }, f = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: o,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: d,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, _ = f;
  e.default = _, r.exports = e.default;
})(Xa, Xa.exports);
var Js = Xa.exports, qa = { exports: {} };
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Q), n = t(ee), i = /^(\d+)(:a|:e)?/i, s = /\d+/i, o = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, d = {
    any: [/^f/i, /^[ev]/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, l = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, _ = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, v = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, M = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, k = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, N = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, $ = {
    ordinalNumber: (0, n.default)({
      matchPattern: i,
      parsePattern: s,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: o,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: N,
      defaultParseWidth: "any"
    })
  }, H = $;
  e.default = H, r.exports = e.default;
})(qa, qa.exports);
var Bs = qa.exports;
(function(r, e) {
  var t = w.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = t(Xs), n = t(qs), i = t(Us), s = t(Js), o = t(Bs), d = {
    code: "sv",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: s.default,
    match: o.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, u = d;
  e.default = u, r.exports = e.default;
})(Ia, Ia.exports);
var Ys = Ia.exports;
const Ks = /* @__PURE__ */ F(Ys), R = {
  da: bi,
  de: Si,
  enAU: Oi,
  enCA: Wi,
  enGB: Zi,
  enIN: Hi,
  enNZ: Li,
  enUS: qi,
  enZA: Bi,
  es: as,
  fr: us,
  it: ws,
  nl: Os,
  pt: Zs,
  ptBR: Vs,
  sv: Ks
}, Gs = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: R.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: R.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: R.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: R.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: R.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: R.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: R.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: R.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: R.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: R.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: R.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Ze = {
  MONTH: "MONTH",
  YEAR: "YEAR"
}, Be = {
  ANNUAL: "annually",
  MONTHLY: "monthly"
}, To = X({
  name: T()
}), Ur = Se(["RECURRING", "ONE_OFF"]), Qs = Se(["STRIPE", "APPLE", "GOOGLE"]), eo = Se([Ze.MONTH, Ze.YEAR]), to = Se([Be.ANNUAL, Be.MONTHLY]), ao = T().regex(/^price_.*$/), Ka = X({
  amount: De(),
  currency: T(),
  id: ao,
  metadata: X({
    repub: Se(Object.keys(Gs))
  }),
  recurring: X({
    count: De(),
    interval: Se(
      Object.values(Ze)
    )
  }),
  type: Ur
}), ro = T().regex(/^prod_.*$/), Ke = X({
  defaultPrice: T().optional(),
  description: T(),
  features: tt(X({ name: T() })),
  id: ro,
  images: tt(T()),
  metadata: fi(T(), ci()),
  name: T(),
  prices: tt(Ka)
}), no = Ke.extend({
  name: T().includes("Premium")
}), io = Ke.extend({
  name: T().includes("Essential")
}), Ao = X({
  affiliateId: T().optional(),
  authToken: T().optional(),
  couponCode: T().optional(),
  customerLocale: T().optional(),
  deviceId: T().optional(),
  priceId: T(),
  provider: Qs.optional(),
  quantity: De().optional(),
  trialDays: De().optional(),
  type: Ur,
  urls: X({ cancelUrl: T(), successUrl: T() })
}), No = X({
  authToken: T().optional(),
  deviceId: T().optional()
}), Wo = X({
  authToken: T().optional(),
  customerLocale: T().optional(),
  deviceId: T().optional(),
  returnUrl: T()
}), zo = X({
  price: Ka,
  product: Ke,
  receipt: X({
    id: T(),
    timestamp: T()
  }),
  startDate: T(),
  endDate: T(),
  type: T(),
  status: T(),
  provider: T()
}), Do = X({
  name: T()
}), Ar = X({
  apiKey: T(),
  authToken: T().optional(),
  deviceId: T(),
  maxRetryAttempts: De().optional()
}), Zo = mi([
  Ar.extend({
    apiHost: T(),
    environment: et(),
    platform: et()
  }),
  Ar.extend({
    apiHost: et(),
    environment: Zn,
    platform: $n
  })
]).refine(
  (r) => !!r.apiHost && !r.environment && !r.platform || !r.apiHost && !!r.environment && !!r.platform,
  {
    message: "Must provide either apiHost OR both environment and platform, but not both"
  }
);
function $o(r) {
  switch (r) {
    case Ze.MONTH:
      return Be.MONTHLY;
    case Ze.YEAR:
      return Be.ANNUAL;
    default:
      throw new Error("Invalid subscription term");
  }
}
function Ro(r) {
  return eo.safeParse(r).success;
}
function Ho(r) {
  return to.safeParse(r).success;
}
function Io(r) {
  return Ka.safeParse(r).success;
}
function Fo(r) {
  return Ke.safeParse(r).success;
}
function Lo(r) {
  return no.safeParse(r).success;
}
function Vo(r) {
  return io.safeParse(r).success;
}
export {
  Ze as SUBSCRIPTION_INTERVAL,
  Be as SUBSCRIPTION_TERM,
  Ao as checkoutOptionsSchema,
  To as featureSchema,
  $o as getSubscriptionTerm,
  No as getSubscriptionsOptionsSchema,
  Vo as isValidOCEssentialProduct,
  Lo as isValidOCPremiumProduct,
  Io as isValidPrice,
  Fo as isValidProduct,
  Ro as isValidSubscriptionInterval,
  Ho as isValidSubscriptionTerm,
  io as ocEssentialProductSchema,
  no as ocPremiumProductSchema,
  Wo as portalSessionOptionsSchema,
  ao as priceIdRegex,
  Ka as priceSchema,
  Ke as productSchema,
  Ur as productTypeSchema,
  Qs as providerSchema,
  Ar as sdkConstructorBaseParamsSchema,
  Zo as sdkConstructorParamsSchema,
  eo as subscriptionIntervalSchema,
  to as subscriptionTermSchema,
  Do as userNewsletterSchema,
  zo as userSubscriptionSchema
};
